<template>
    <div>
        <multiselect
            :selectLabel="t('Select')"
            :selectGroupLabel="t('Select group')"
            :deselectLabel="t('Deselect')"
            :deselectGrouLabel="t('Deselect group')"
            :placeholder="placeholder"
            :options="options"
            :custom-label="searchLabel"
            group-values="rows"
            group-label="group"
            :group-select="true"
            :label="label"

            :multiple="true"
            :close-on-select="false"
            v-model="selected"
            @input="change"
        >
            <div slot="noOptions">
                {{ t('List is empty') }}
            </div>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    let interval = null;

    export default
    {
        model: {
            props: 'data',
            event: 'change',
        },
        components: {Multiselect},
        props: {
            data: {
                default: null,
            },
            placeholder: {
                type: String,
                default: 'Category',
            },
            groupValues: {
                type: String,
                default: 'rows',
            },
            groupLabel: {
                type: String,
                default: 'group',
            },
            label: {
                type: String,
                default: 'name',
            },
            emptyPlaceholder: {
                type: String,
            },
            interval: {
                type: Number|Boolean,
                default: 2000,
            },
            options: {
                type: Array,
            },
        },
        data() {
            return {
                selected: [],
            };
        },
        mounted()
        {
        },
        methods:
        {
            searchLabel(option) {
                return `${option.name}`
            },
            limitText(count) {
                return ` + ${count}`;
            },
            change()
            {
                const v = this;

                if (this.interval === false)
                {
                    this.$emit('change', this.selected);

                    return ;
                }

                clearInterval(interval);

                interval = setTimeout(() => {
                    v.$emit('change', v.selected);
                }, this.interval);
            },
        },
        watch: {
            data: {
                handler: function(newData, oldData) {
                    this.selected = newData;
                }
            }
        }

    }
</script>



// WEBPACK FOOTER //
// CustomCategory.vue?3adfca6c